import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import $ from 'jquery'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueClipboard from 'vue-clipboard2'
import store from './store/index'
import api from "./api/index.js"
import commonFun from "./common/common-fun.js"
import common from "./common/common.js"
import gettime from './common/time.js'

// import CKEditor from '@ckeditor/ckeditor5-vue'; //编辑器
// import '@ckeditor/ckeditor5-build-classic/build/translations/zh-cn.js'

//全局引入新富文本
import editorBar from "@/components/wangEnduit";
Vue.component('editorBar', editorBar)

//地图显示
import echarts from 'echarts';
import 'echarts/map/js/china.js'; //node_modules中
Vue.prototype.$echarts = echarts

Vue.use(VueClipboard)
Vue.use(VueAxios, axios);
Vue.use(ElementUI);
// Vue.use(CKEditor);


//挂全局组件
import headdv from '@/components/head'
Vue.component('headdv', headdv)
import headdv2 from '@/components/head2'
Vue.component('headdv2', headdv2)
import footerdv from '@/components/footer'
Vue.component('footerdv', footerdv)
import page from '@/components/page'
Vue.component('page', page)


// 挂载全局方法
Vue.prototype.commonFun = commonFun

// 挂载全局变量
Vue.prototype.common = common

// 日期格式化
Vue.prototype.gettime = gettime

// 挂载全局请求方法
Vue.prototype.api = api
Vue.prototype.https = api.https
Vue.prototype.apiList = api.apiList

// 时间格式：下午 4:06
Vue.filter('novelTime', function (value) {
    let time = gettime.gettime(value)
    return time
})
// 时间格式：8/6 18:51:11
Vue.filter('novelTimeHistory', function (value) {
    let time = gettime.format(value, 5)
    return time
})
// 
Vue.filter('format_cc_is_assess', function (value) {
    if (value == '0') {
        return '无评价'
    } else {
        return '有评价'
    }
})

//弹窗
Vue.prototype.tc_element = function (message, status, type, title) {
    if (type == 1) {
        //中间上面往下弹出
        this.$message({
            duration: api.Time_out_tishi,
            message: message,
            type: status == api.SU_STATUS ? "success" : "error",
        });
    } else if (type == 2) {
        //右上角上面往下弹出
        this.$notify({
            duration: api.Time_out_tishi,
            title: title,
            // type: status ? "success" : "warning",
            type: status == api.SU_STATUS ? "success" : "warning",
            message: message
        });
    }
}


//loding
Vue.prototype.loading = function () {
    this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
    });
}

/**
 * 路由劫持，如果没有令牌则跳转到登录页面
 */
// router.beforeEach((to, from, next) => {
//     let $token = localStorage.getItem(api.AUTH_TOKEN_FLAG);
//     //console.log("路由劫持--判断有没有tomen"+$token)
//     if ($token === '' || $token === undefined) {
//         if (to['name'] !== 'login') {
//             next({
//                 name: 'login'
//             });
//         }
//     }
//     next();
// });

Vue.config.productionTip = false
new Vue({
    render: h => h(App),
    router,
    store
}).$mount('#app')